import React, { useEffect, useState } from 'react';
import '../index.css';
import '../style/template.css'
import '../style/shared.css';
import { Stack, ToolbarButton } from '@blueprism/ui-core';
import { Table, TableToolbar, useSelectedRows } from '@blueprism/ui-pattern-table';
// import { ToolbarButton } from '@blueprism/ui-pattern-toolbar';
import { TriangleInCircle, Trash, List, Pencil } from '@blueprism/ui-icons';
import { ModalWindow } from '@blueprism/ui-pattern-modal';
import { useFormValue } from '../services/FormValueProvider';
// import { fakeTemplates } from '../env_data/fakeTemplates';
import { useNavigate } from "react-router-dom";

const columns = [
  {
    header: 'Template Name',
    accessor: 'name',
    width: '10rem',
    disableSort: false
    // tableCell: (value) => format(value),
  },
  {
    header: 'Created',
    accessor: 'created_at',
    width: '10rem',
    disableSort: false
    // tableCell: (value) => format(value),
  },
  {
    header: 'Last Updated',
    accessor: 'last_updated',
    width: '10rem',
    disableSort: false
    // tableCell: (value) => format(value),
  },
  {
    header: 'Template Id',
    accessor: 'id',
    width: '5rem',
    disableSort: false,
    // tableCell: (value) => format(value),
  },
]

function TemplateTable({ tableType }) {
  const navigate = useNavigate();
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false)
  const [, setTableType] = React.useState()
  const [, setTableActions] = React.useState([])
  const [deleteTemplateIds, setDeleteTemplateIds] = React.useState([])
  const [deleteTemplateNames, setDeleteTemplateNames] = React.useState([])
  const [templates, setTemplates] = React.useState([])
  const [, setLoadingTemplates] = React.useState(true)
  const [value, setValue] = React.useState(0)
  const formreq = useFormValue();

  const {
    selectedRowIds,
    noRowsSelected,
    singleRowSelected,
    handleRowSelectionChange,
    handleCheckboxStatusChange
  } = useSelectedRows([]);


  //TABLE FUNCTIONS
  function onHeaderClick(e) {
    e.preventDefault();
  }

  function generateTableActions() {
    if (tableType === "templates") {
      setTableActions([
        <ToolbarButton label="Test Template" icon={<TriangleInCircle />} disabled={noRowsSelected || !singleRowSelected} onClick={runSelectedTemplate} />,

        <ToolbarButton label="Edit Template" icon={<Pencil />} disabled={noRowsSelected || !singleRowSelected} onClick={editSelectedTemplate} />,

        <ToolbarButton label="Template History" icon={<List />} disabled={noRowsSelected || !singleRowSelected} onClick={viewTemplateHistory} />,

        <ToolbarButton label="Delete" icon={<Trash />} disabled={noRowsSelected} onClick={deleteSelectedTemplate} />
      ])
    }
    else if (tableType === "version-history") {
      setTableActions([
        <ToolbarButton label="Test Template Version" icon={<TriangleInCircle />} disabled={noRowsSelected || !singleRowSelected} onClick={runSelectedTemplate} />,

        <ToolbarButton label="Edit Version" icon={<Pencil />} disabled={noRowsSelected || !singleRowSelected} onClick={editSelectedTemplate} />,

        <ToolbarButton label="Delete Version(s)" icon={<Trash />} disabled={noRowsSelected} onClick={deleteSelectedTemplate} />
      ])
    }
  }

  const getTemplates = () => {
    formreq.getTemplates(localStorage.getItem("site")).then((response) => {
      response.forEach((temp) => {
        var createdDate = new Date(temp.created_at)
        var lastUpdated = new Date(temp.last_updated)
        temp.created_at = createdDate.toLocaleString()
        temp.last_updated = lastUpdated.toLocaleString()
      })
      setTemplates(response)
      setLoadingTemplates(false)
    })
  }


  //DELETE FUNCTIONS
  function handleDeleteModalOpen(templatesToDelete) {
    let deleteTemplateNames = []
    templatesToDelete.forEach(i => deleteTemplateNames.push(i['name']))
    setDeleteTemplateNames(deleteTemplateNames)
    setOpenDeleteModal(true);
  }

  function handleDeleteModalClose() {
    setOpenDeleteModal(false)
  }

  function handleDeleteConfirmationClick() {
    deleteTemplateIds.forEach((templateId) => formreq.deleteTemplate(templateId, localStorage.getItem("site")).then((response) => {
      console.log("deleted")
    }))
    getTemplates()
    handleDeleteModalClose()
  }

  function deleteSelectedTemplate(e) {
    let delete_template_ids = selectedRowIds
    let templatesToDelete = []
    delete_template_ids.forEach(i => {
      templatesToDelete.push(templates.find((j => j["id"] === i)))
    });
    setDeleteTemplateIds(delete_template_ids)
    handleDeleteModalOpen(templatesToDelete)
  }

  //EDIT FUNCTIONS
  function editSelectedTemplate(e) {
    //get seleted row id
    let template_id = selectedRowIds
    navigate('/template-edit/' + template_id)
  }


  // VIEW HISTORY FUNCTIONS
  function viewTemplateHistory(e) {
    let template_id = selectedRowIds
    navigate('/template-version-history/' + template_id)
  }


  //RUN FUNCTIONS
  function runSelectedTemplate(e) {
    let template_id = selectedRowIds
    navigate('/template-run/' + template_id)
  }

  useEffect(() => {
    getTemplates()
    setTableType(tableType);
    generateTableActions();
  }, []);

  return (
    <div className='templateTable'>
      <Stack gap="base">
        <TableToolbar customContextualButtons=
          {[
            <ToolbarButton label="Test Template" icon={<TriangleInCircle />} disabled={noRowsSelected || !singleRowSelected} onClick={runSelectedTemplate} />,
            <ToolbarButton label="Edit Template" icon={<Pencil />} disabled={noRowsSelected || !singleRowSelected} onClick={editSelectedTemplate} />,
            <ToolbarButton label="Template History" icon={<List />} disabled={noRowsSelected || !singleRowSelected} onClick={viewTemplateHistory} />,
            <ToolbarButton label="Delete" icon={<Trash />} disabled={noRowsSelected} onClick={deleteSelectedTemplate} />
          ]} />

        <Table rowData={templates} columns={columns} sortColumns selectedIds={selectedRowIds} selectRows onRowSelectionChange={handleRowSelectionChange} onHeaderCheckboxClick={handleCheckboxStatusChange} />
      </Stack>

      <ModalWindow open={openDeleteModal} onClose={handleDeleteModalClose} modalId="modal-1" modalHeaderTitle="Delete Templates?" closeIconButton="true" primaryActionText="Confirm Delete" onPrimaryActionClick={handleDeleteConfirmationClick}>
        Are you sure you want to delete the following template(s)?
        {deleteTemplateNames.map(name => (<li>{name}</li>))}
      </ModalWindow>
    </div>
  );
}

export default TemplateTable;